/**
 * @fileoverview The signed-in Banking-role user's own bank logo mark.
 * @description Used wherever a Banking-role user's own bank identity replaces the static
 * InsightBox mark — the dashboard header and the sidebar's brand slot. Ported directly from the
 * InsightBox Banking design system's own `hsh-bank-mark.svg` asset (a self-contained circular
 * mark — gradient fill, gold ring, pediment/column glyph, and the bank's own initials baked in),
 * matching this app's one mock bank ("HSH Co-operative Bank Ltd."). This is genuinely tied to that
 * one bank's name rather than a generic reusable mark — if this app ever needs to render more than
 * one bank's identity, this component (and its one asset) would need to become data-driven instead
 * of a fixed import.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import hshBankMarkUrl from '@/assets/images/banking/hsh-bank-mark.svg'

interface BankBadgeProps {
  size?: number
}

/**
 * @component
 * @param {BankBadgeProps} props - The badge's diameter.
 * @param {number} [props.size] - Diameter in pixels. Defaults to 32.
 */
function BankBadge({ size = 32 }: BankBadgeProps) {
  return (
    <img
      src={hshBankMarkUrl}
      alt=""
      className="shrink-0 rounded-full shadow-sm"
      style={{ width: size, height: size }}
    />
  )
}

export default BankBadge
